import { app } from 'app/providers/FirebaseProvider/ui/FirebaseProvider'
import { getAuth } from 'firebase/auth'
import { backendForFirebaseUser } from './backendForFirebaseUser'

export const fetchTopCreators = async () => {
    const backend = backendForFirebaseUser(getAuth(app).currentUser)
    if (!backend) return []

    const result = await backend.getTopCreators()
    return result.creators
}
